import { IonicModule } from '@ionic/angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {EmailTemplateRoutingModule} from "./emailTemplate-routing.module";
import {NgxDatatableModule} from "@swimlane/ngx-datatable";
import {TableModule} from "../generic/table/table.module";
import {CourseService} from "../../../service/CourseService";
import {EmailTemplate} from "./emailTemplate";
import {NgSelectModule} from "@ng-select/ng-select";
import {DlDateTimePickerModule} from "angular-bootstrap-datetimepicker";
import {ContextService} from "../../../service/ContextService";
import {PickerModule} from "@ctrl/ngx-emoji-mart";
import {AngularEditorModule} from "@kolkov/angular-editor";
import {EmailTemplateService} from "../../../service/EmailTempalteService";
import {NgToggleModule} from "ng-toggle-button";

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    FormsModule,
    EmailTemplateRoutingModule,
    NgxDatatableModule,
    TableModule,
    NgSelectModule,
    DlDateTimePickerModule,
    PickerModule,
    AngularEditorModule,
    NgToggleModule,
  ],
  providers: [EmailTemplateService, ContextService],
  exports: [
    EmailTemplate
  ],
  declarations: [EmailTemplate]
})
export class EmailTemplateModule {}
